// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_fy","catalogByServiceItem__title":"c-k_fz"};